import { render, staticRenderFns } from "./ArticleDetailWrap.vue?vue&type=template&id=70fa71ef&scoped=true&"
import script from "./ArticleDetailWrap.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailWrap.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetailWrap.vue?vue&type=style&index=0&id=70fa71ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa71ef",
  null
  
)

export default component.exports